<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <div v-if="mode == 'search'">
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.FAQ.CORP') }}</li>
                                <li data-input-type="select" class="w100-150">
                                    <fieldset class="ui_fieldset set_2">
                                        <div>
                                            <select class="slt_white w100p" v-model="rhqCd" @change="changeRhqCd()">
                                                <option v-if="rhqCdList.length > 1" value="" selected >{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100p" v-model="corpNo">
                                                <option v-if="corpNoList.length != 1" value selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.GLOBAL.STATUS') }}</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="loginStatus">
                                        <option value selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="code in statTypes"
                                            :key="code.code"
                                            :value="code.code"
                                        >
                                            {{
                                            code.codeDesc
                                            }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.USER.TEAM') }}</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="teamNo">
                                        <option value selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="code in teamTypes"
                                            :key="code.code"
                                            :value="code.code"
                                        >
                                            {{
                                            code.codeName
                                            }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.USER.ROLE') }}</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="role">
                                        <option value selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="code in roleTypes"
                                            :key="code.code"
                                            :value="code.code"
                                        >
                                            {{
                                            code.codeName
                                            }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.USER.ID')}}</li>
                                <li data-input-type="text" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" ref="userId" class="text_input w100" v-model="userId" @keyup.enter.stop="onSearch(1)" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a href="JavaScript:" class="btn_srch" @click="onSearch(1)">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                            </span>
                        </div>
                    </article>
                </div>

                <!-- Grid -->
                <div class="grid_wrap">
                    <div class="grid_total">{{ $t('TITLE.TOTAL.COUNT') }} : <em>{{ resultCount | numberFormat }}</em></div>
                    <!-- Grid -->
                    <role-list-grid
                        :gridId="gridId"
                        :data="gridData"
                        :columns="columns"
                        :options="options"
                        :pageOptions="pageOptions"
                        :key="gridKey"
                        :click="contentClick"
                        :isTotalCount="false"
                        :menuMode="menuMode"
                    />
                </div>
            </div>
            <content-view v-if="mode !== 'search'" :pLoginNo="userNo"></content-view>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue              from 'vue';
import axios            from 'axios';
import qs               from 'query-string';
import _                from 'lodash';
import $                from 'jquery';
import constants        from '@/constants';
import SDLLocale        from '@/mixin/SDLLocale';
import SDLPagination    from '~~c/control/pagination/Pagination';
import { SDLUtil }      from '@/utils';
import { EventBus }     from '@/utils/EventBus';
import SKPBreadcrumbs   from '~vb/main/SKPBreadcrumbs';
import UserListGrid     from '~c/ToastGrid';
import UserAdminView    from './UserAdminView';
import { mapGetters }   from 'vuex';
import api from '@/service';

class TooltipRenderer {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        el.innerText = resVal;
        el.title = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};
// ToastGrid UseYn Type renderer
export default {
    name: 'UserAdminList',
    props: {
        params: {},
    },
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'sdl-pagination': SDLPagination,
        'role-list-grid': UserListGrid,
        'content-view': UserAdminView,
    },
    data() {
        return {
            isLoading: true,
            mode: 'search', // 'view'
            loadingStatus: 'loading', // 'done', 'error'
            searchStatus: 'done', // 'loading', 'disabled'
            menuMode: 'USER',
            SUPER_ADMIN : '1175357',
            pageTitle: '',
            rhqCdList: [],
            corpNoList: [],
            userId: '',
            rhqCd: '',
            rhqCds: [],
            corpNo: '',
            loginStatus: '',
            teamNo: '',
            role: '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            gridKey: 0,
            resultCount: 0,
            ORDER_COLUMN: '',
            ORDER_ASC: '',
            sortOrder: null, // ASC or DESC
            orgOrderCol: null,
            gridId: 'UserAdminGrid',
            options: {},
            pageOptions: {},
            gridData: [],
            statTypes: [],
            teamTypes: [],
            roleTypes: [],
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.FAQ.CORP'),
                    name: 'LOGINCORPNAME',
                    //width: 140,
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.ID'),
                    name: 'LOGINID',
                    //width: 220,
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.NAME'),
                    name: 'LOGINNAME',
                    renderer: {type: TooltipRenderer },
                    //                    width: 300,
                     align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.TEAM'),
                    name: 'TEAMNAME',
                   // width: 150,
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'),
                    name: 'STATUSNM',
                    //width: 160,
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.ON'),
                    name: 'REGDATE',
                    align: 'center',
                    //width: 170,
                    sortable: true,
                },{
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MOBILE'),
                    name: 'HHP_STATUS',
                    align: 'center',
                    //width: 100,
                    sortable: true,
                },
            ],
            options: {
                scrollY: false,
                scrollX: false,
                rowHeight: 25,
            },
            pageOptions: {
                useClient: true,
                perPage: parseInt(localStorage.getItem('listRows') || 10),
            }
        };
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(mode, pCode) {
            if (mode == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.rhqCdList = data;
                    if (this.rhqCdList.length == 1) this.rhqCd = this.rhqCdList[0].code;
                    if (this.rhqCd) this.loadSubsiCodes(2, this.rhqCdList[0].code);
//                    else this.corpNo = '';
                });
            } else if (mode == 2) {
                // CorpNo
                this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                    this.corpNoList = data;
                    if (this.corpNoList.length == 1) this.corpNo = this.corpNoList[0].code;
                    else                             this.corpNo = '';
                });
            }
        },
        loadCommonCodes() {
            let param = {};
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/user/userMngComCodes.skp`, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.statTypes = resp.data.statTypes;
                    this.teamTypes = resp.data.teamTypes;
                    this.roleTypes = resp.data.roleTypes;
                })
                .catch(err => {
                    console.log('Error occured : ', err);
                });
        },
        onSearch(pageNo) {
            if (!pageNo) pageNo = 1;

            let userIdLen = this.userId.trim().length;
            if (userIdLen < 1) {
                SDLUtil.alert('MESSAGE.ALERT.SEARCH.USERID');
                return;
            }
/*
            if (this.SUPER_ADMIN !==  this.loginNo && userIdLen < 3) {
                SDLUtil.alert('MESSAGE.SEARCH.USER');
                return;
            } else if (this.SUPER_ADMIN == this.loginNo && userIdLen < 3) {
                if (!this.corpNo) {
                    SDLUtil.alert({
                        msg: 'MESSAGE.USER.SEARCH.VALID',
                        onOkEvt: () => {
                            this.$refs.userId.focus();
                        }
                    });
                    return;
                }
            }
*/
            const formData = this.prepSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            this.gridData = [];
            this.searchStatus = 'loading';
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/user/userAdminList.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.gridData = resp.data.rows;
                    this.resultCount = resp.data.totalCount;

                    // Server에서 결과가 10개 미만일 때 항상 10을 돌려주는 문제를 임시적으로 해결하는 if문
                    if (
                        this.resultCount === 10 &&
                        typeof resp.data.rows !== 'undefined' &&
                        resp.data.rows.length < 10
                    ) {
                        this.resultCount = resp.data.rows.length;
                    }
                    this.searchStatus = 'done';
                    this.loadingStatus = 'done';

                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        changeRhqCd() {
            if (this.rhqCd == '') {
                this.corpNoList = [];
                this.corpNo = '';
            } else {
                this.loadSubsiCodes(2, this.rhqCd);
            }
        },
        // 그리드 row 클릭 시...
        clickCreate() {
            this.userId = null;
            this.mode = 'view';
        },
        // 그리드 row 클릭 시... 상세페이지로 이동
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;
            SDLUtil.showLoadingBar(true);

            let item = this.gridData[event.rowKey];
            this.userNo = item.LOGINNO;
            this.mode = 'view';

            window.scrollTo(0, 0);
            SDLUtil.showLoadingBar(false);
        },
        //
        prepSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;

            // rhqCd가 All일 때 권한내에 있는 CD로만 검색해야 함...
            this.rhqCds = [];
            if (!this.rhqCd) {
                this.rhqCdList.forEach(elm => {
                    this.rhqCds.push(elm.code);
                });
            } else { this.rhqCds = null; }

            let params = {
                page: pageNo,
                currentPage: pageNo,
                perPage: this.perPage,
                rhqCd: this.rhqCd,
                rhqCds: this.rhqCds,
                loginCorp: this.corpNo,
                loginId: this.userId,
                loginStatus: this.loginStatus,
                teamNo: this.teamNo,
                authCorpId: this.role,
//                ORDER_COLUMN: this.ORDER_COLUMN,
//                ORDER_ASC: this.ORDER_ASC,
            };
            return params;
        },

        clickSearch() {
            this.onSearch(1);
        }, // clickSearch
        goBackList(data) {
            this.onSearch(this.currentPage);
            this.mode = 'search';
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            this.ORDER_COLUMN = sortObj.columnName;

            if (this.ORDER_COLUMN != this.orgOrderCol) {
                this.sortOrder = null;
            }
            if (this.sortOrder == null) this.sortOrder = 'ASC';
            else if (this.sortOrder == 'ASC') this.sortOrder = 'DESC';
            else if (this.sortOrder == 'DESC') {
                this.sortOrder = null;
                this.ORDER_COLUMN = null;
            }

            this.ORDER_ASC = this.sortOrder;
            this.orgOrderCol = this.ORDER_COLUMN;
            this.onSearch(1);
        },
    }, // methods
    created() {
        EventBus.$on('goUserList', this.goBackList);
        EventBus.$on('sort-search-user', sortForm => {
            this.handleSortSearch(sortForm);
        });
    },
    mounted() {
        this.loadSubsiCodes(1, '');
        this.loadCommonCodes();
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('goUserList');
        EventBus.$off('sort-search-user');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/user/UserAdminList.vue